import React from "react";
import { Pressable, Text, View } from "react-native";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import { useTheme } from "../../../theme";
import styles from "../MyTicketsScreenStyles";
import mobileStyles from "../MyTicketsScreen.mobile.style";

type Props = {
  onBackToPortal: () => void;
  onNewTicket: () => void;
  totalCount?: number;
  mobile?: boolean;
};

const MyTicketsHeader: React.FC<Props> = ({ onBackToPortal, onNewTicket, totalCount, mobile }) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  if (mobile) {
    return (
      <View style={[mobileStyles.headerBlock, isDark && { backgroundColor: colors.background.surface, borderBottomWidth: 1, borderBottomColor: colors.border.divider }]}>
        <View style={mobileStyles.headerLeft}>
          <Pressable accessibilityRole="button" onPress={onBackToPortal} style={mobileStyles.backArrowWrap}>
            <MaterialIcons name="arrow-back" size={22} color={isDark ? colors.text.primary : "#1a2332"} />
          </Pressable>
          <View style={mobileStyles.headerTitleBlock}>
            <Text style={[mobileStyles.headerTitle, isDark && { color: colors.text.primary }]}>My Tickets</Text>
            {totalCount !== undefined ? (
              <Text style={[mobileStyles.headerSubtitle, isDark && { color: colors.text.secondary }]}>Showing {totalCount} tickets</Text>
            ) : null}
          </View>
        </View>
        <Pressable
          accessibilityRole="button"
          onPress={onNewTicket}
        >
          <MaterialIcons name="add" size={28} color={isDark ? colors.text.primary : "#1a2332"} />
        </Pressable>
      </View>
    );
  }

  return (
    <View style={styles.pageHeader}>
      <View style={styles.pageTitleBlock}>
        <View style={styles.breadcrumbRow}>
          <Pressable onPress={onBackToPortal}>
            <Text style={[styles.breadcrumbLink, isDark && { color: colors.text.secondary }]}>Ticket Portal</Text>
          </Pressable>
          <Text style={[styles.breadcrumbSeparator, isDark && { color: colors.text.disabled }]}>{'>'}</Text>
          <Text style={[styles.breadcrumbCurrent, isDark && { color: colors.text.primary }]}>My Tickets</Text>
        </View>
        <Text style={[styles.pageTitle, isDark && { color: colors.text.primary }]}>My Tickets</Text>
        {totalCount !== undefined ? (
          <Text style={[styles.pageSubtitle, isDark && { color: colors.text.secondary }]}>
            Showing {totalCount} {totalCount === 1 ? "ticket" : "tickets"} where you are the submitter or a stakeholder.
          </Text>
        ) : null}
      </View>

      <View style={styles.pageActions}>
        <Pressable style={({ pressed }) => [styles.btnPrimary, pressed ? styles.btnPrimaryPressed : null]} onPress={onNewTicket}>
          <MaterialIcons name="add" size={15} color="#ffffff" />
          <Text style={styles.btnPrimaryText}>New Ticket</Text>
        </Pressable>
      </View>
    </View>
  );
};

export default MyTicketsHeader;
